<template>
  <div>
    <b-modal v-model="openBuyoutModal" :title="title" size="lg" @ok.prevent="attemptBuyoutSubmit = true"
      @cancel="editingBuyout = false">
      <buyout-form v-model="attemptBuyoutSubmit" :terms="terms" :editingBuyout="editingBuyout ? selectedBuyout : null"
        v-on:complete="processBuyoutRequest" v-if="openBuyoutModal"></buyout-form>
    </b-modal>

    <b-modal v-model="confirmDeletion" title="Confirm Delete" v-if="selectedBuyout" @ok="removeBuyout(selectedBuyout)"
      @cancel="clearBuyout()">
      Are you sure you want to delete this buyout?
      <div v-for="(grant, index) in selectedBuyout.grants" :key="index">
        {{ grant.description }}
      </div>
      <div>
        {{ selectedBuyout.notes }}
      </div>
    </b-modal>

    <table-widget :items="buyouts" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage"
      :filter.sync="filter">
      <template slot="buttons">
        <b-button v-if="editable" @click="openBuyoutAdd()" class="ml-2" variant="primary"><font-awesome-icon
            icon="plus" />Add Buyout</b-button>
      </template>
      <template slot="content">
        <!-- <b-alert :show="editable"
          ><font-awesome-icon icon="exclamation-circle" /> Buyout requests are
          not saved until you click the submit button below.</b-alert
        > -->
        <b-table striped :items="selectedBuyouts" :fields="fields" :per-page="perPage" :current-page="currentPage"
          :filter="filter" @filtered="onFiltered" small show-empty :tbody-transition-props="transProps"
          empty-filtered-text="There are no buyouts that match your search criteria.">
          <template v-slot:cell(createdDate)="data">
            <template v-if="data.item.createdDate">
              {{ data.item.createdDate | formatDateTime }}
            </template>
            <template v-else> Not Submitted </template>
          </template>
          <template v-slot:cell(grants)="data">
            <div v-for="(grant, index) in data.item.grants" :key="index">
              {{ grant.description }}
            </div>
          </template>
          <template v-slot:cell(numberOfClasses)="data">
            {{ data.item.numberOfClasses || 0 }}
          </template>
          <template v-slot:cell(status)="data">
            {{ data.item.currentStatus.statusName }}
          </template>
          <template v-slot:cell(controls)="data">
            <div class="text-right" v-if="
              (data.item.currentStatus.statusName == 'Submitted' ||
                data.item.currentStatus.statusName == 'Not Submitted') &&
              editable
            ">
              <font-awesome-icon icon="pencil-alt" class="edit-icon mx-1"
                @click="openBuyoutEdit(data.item)"></font-awesome-icon>
              <font-awesome-icon icon="times" class="remove-icon mx-1"
                @click="confirmRemoveBuyout(data.item)"></font-awesome-icon>
            </div>
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import BuyoutForm from "@/components/workloads/buyout-form"
import TableWidget from "../table-widget"
import * as _ from "lodash" // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      transProps: {
        // Transition name
        name: "fade"
      },
      items: [],
      fields: [
        { key: "term.description", label: "Semester" },
        { key: "status", label: "Status" },
        { key: "grants", label: "Grants" },
        { key: "numberOfClasses", label: "Number of Classes" },
        { key: "createdDate", label: "Date" },
        { key: "controls", label: "" }
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      selectedBuyouts: [],
      openBuyoutModal: false,
      editingBuyout: false,
      selectedBuyout: null,
      attemptBuyoutSubmit: false,
      confirmDeletion: null
    }
  },

  props: {
    buyouts: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    title: {
      type: String,
      required: false,
      default: function () {
        return "New Buyout Request"
      }
    },
    editable: {
      type: Boolean,
      required: false,
      default: function () {
        return true
      }
    },
    terms: {
      type: Array,
      required: true
    }
  },

  components: { "table-widget": TableWidget, BuyoutForm },

  computed: {},

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openBuyoutAdd: function () {
      this.openBuyoutModal = true
    },
    openBuyoutEdit: function (buyout) {
      this.selectedBuyout = buyout
      this.editingBuyout = true
      this.openBuyoutModal = true
    },
    processBuyoutRequest: function (buyout) {
      this.attemptBuyoutSubmit = false
      if (buyout) {
        if (this.editingBuyout) {
          //this.submitEditBuyout(buyout);
          this.$emit("edited", buyout)
        } else {
          this.$emit("added", buyout)
          //this.workload.buyoutRequests.push(buyout);
          //this.submitNewBuyout(buyout);
        }
        this.openBuyoutModal = false
      }
      this.editingBuyout = false
    },
    confirmRemoveBuyout(buyout) {
      this.selectedBuyout = buyout
      this.confirmDeletion = true
    },
    removeBuyout(buyout) {
      //this.buyouts.splice(index, 1);
      this.$emit("removed", buyout)
    },
    clearBuyout() {
      this.selectedBuyout = null
    }
  },

  watch: {
    buyouts: function () {
      if (this.buyouts.length) {
        this.selectedBuyouts = this.buyouts
        this.totalRows = this.buyouts.length
      }
    }
  },

  created() {
    if (this.buyouts.length) {
      this.selectedBuyouts = this.buyouts
      this.totalRows = this.buyouts.length
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
